import React from "react";
import { bytesToReadableUnit } from "~/utils/formatter";

//Assets
import "~/assets/sass/pages/portfolio/portfolioMemo.scss";
import {
	DownloadIcon,
	FileLinkIcon
} from "~/assets/svg/InterfaceIcon";

const FileItem = ({file}) => {
  return(
    <li className="file-item">
      <div className="file-icon">
        <FileLinkIcon />
      </div>
      <div className="file-contents">
        <p className="file-text">{file.fileName}</p>
        <p className="file-data">{bytesToReadableUnit(file.fileSize)}</p>
      </div>
      <div className="file-download">
        <a href={file.fileUrl} download>
          <DownloadIcon />
        </a>
      </div>
    </li>
  )
}

export default FileItem;
